import { render } from "./period-picker-header.vue?vue&type=template&id=1b59670a"
import script from "./period-picker-header.vue?vue&type=script&lang=js"
export * from "./period-picker-header.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__